export const Services = {
   "Get_Shipment": {
      "path": "https://rrapishipments.azurewebsites.net/",
      "method": "POST",
      "descrp": "data shipments"
   },
   "Get_ShipmentId": {
      "path": "https://rrapishipments.azurewebsites.net/",
      "method": "GET",
      "descrp": "get data shipment"
   },
   "Get_DataMap": {
      "path": "https://rrapishipments.azurewebsites.net/",
      "method": "POST",
      "descrp": "data map in tracking"
   },
   "Get_ContainerId": {
      "path": "https://rrapishipments.azurewebsites.net/",
      "method": "GET",
      "descrp": "get container"
   },
   "Get_Events_General": {
      "path": "https://rrapievents.azurewebsites.net/",
      "method": "GET",
      "descrp": "Get events"
   },
   "Get_Traceability_Shipments": {
      "path": "https://rrapishipments.azurewebsites.net/",
      "method": "POST",
      "descrp": "get catalogos shipments"
   },
   "Get_DocumentsId": {
      "path": "https://rrapidocuments.azurewebsites.net/",
      "method": "GET",
      "descrp": "Get documents for id"
   },
   "generate_xls": {
      "path": "https://servicereportapi.azurewebsites.net/report/dynamic/xlsx",
      "method": "",
      "descrp": "Dowload xls"
   }
}